import {
  PATHS as COMMON_PATHS,
  Setting as COMMON_SETTING,
} from '@baseball-near-you/common';
import type { Route } from 'next';

export enum UnusableSlugs {
  admin = 0,
  api = 1,
  auth = 2,
  blog = 3,
  fonts = 4,
  login = 5,
  marketing = 6,
  onboarding = 7,
  settings = 8,
  'sign-up' = 9,
  teams = 10,
}

export const COOPERSTOWN_HALL_OF_FAME_COORDS = {
  lat: 42.70182,
  lng: -74.929047,
};

// Re-export PATHS and Setting from common with Route typing
export const PATHS = COMMON_PATHS as Record<keyof typeof COMMON_PATHS, Route>;
export const Setting = COMMON_SETTING as Record<
  keyof typeof COMMON_SETTING,
  Route
>;

// Helper function to concatenate routes while maintaining Route type
export const route = (...segments: (Route | string)[]): Route =>
  segments.join('') as Route;
